<template>
  <v-container class="form-container">
    <v-row no-gutters>
      <v-btn icon small color="primary" @click="$router.back()" class="mr-2">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <h3>{{ ctrl.formData.name }} - Send</h3>
    </v-row>

    <v-divider class="my-2"></v-divider>

    <v-card>
      <v-card-text>
        <v-form ref="form">
          <v-row no-gutters align="center">
            <span class="subtitle-1 mr-2">
              <b>Filters :</b>
            </span>
            <v-autocomplete
              dense
              outlined
              multiple
              :items="filters"
              v-model="selectedFilters"
              item-text="value"
              item-value="id"
              hide-details
            >
              <template v-slot:item="data">
                <template v-if="isObject(data.item)">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ data.item.value }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                </template>
              </template>
            </v-autocomplete>
          </v-row>

          <v-row no-gutters align="center" class="mt-2">
            <span class="subtitle-1 mr-2">
              <b>Recipients :</b>
            </span>
            <v-autocomplete
              v-model="selectedRecipients"
              :items="provider_ctrl.employees"
              :item-text="(val) => `${val.firstName} ${val.lastName}`"
              item-value="id"
              dense
              deletable-chips
              outlined
              hide-details
              multiple
              :search-input.sync="search"
              :loading="provider_ctrl.loading"
              chips
            ></v-autocomplete>
          </v-row>

          <v-row no-gutters align="center" class="mt-2">
            <span class="subtitle-1 mr-2">
              <b>Valid Until :</b>
            </span>

            <v-text-field
              dense
              outlined
              type="date"
              v-model="expiryDate"
              hide-details
            ></v-text-field>
          </v-row>

          <v-divider class="my-2"></v-divider>

          <v-row no-gutters>
            <v-spacer></v-spacer>
            <v-btn small color="primary" outlined @click="send">
              <v-icon small class="mr-1">mdi-send</v-icon> Send
            </v-btn>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      employees: [],
      selectedRecipients: [],
      selectedFilters: [],
      search: "",
      ctrl: this.get_controller("workflow"),
      provider_ctrl: this.get_controller("data_provider"),
      expiryDate: null,
    };
  },
  mounted() {
    this.provider_ctrl.getFilters();
  },
  watch: {
    search(val) {
      if (val != null && val != "" && !this.provider_ctrl.loading) {
        this.provider_ctrl.findUser(val);
      }
    },
  },
  computed: {
    filters() {
      let retVal = [];

      this.provider_ctrl.filters.forEach((element) => {
        retVal.push({ header: element.name });

        retVal = retVal.concat(element.values);
      });

      return retVal;
    },
    request() {
      return {
        workflowId: this.$route.params.id,
        expiryDateTime: this.expiryDate,
        userIds: this.selectedRecipients,
        providerFilterIds: this.selectedFilters,
      };
    },
  },
  methods: {
    send() {
      this.post(`Workflow/Assign`, this.request).then(() => {
        this.$router.back();
      });
    },
    isObject(item) {
      return typeof item == "object";
    },
  },
};
</script>

<style>
</style>